import { prependRoot } from "../../util/prependRoot.js";
import { getApiRoot } from "../../store/configureStore.js";
import axios from "axios";

const ContactApi = {
    getContactsByAccount(accountId) {
        const path = accountId ? "/contact/getall/" + accountId : "/contact/getall";
        const serviceUrl = prependRoot(path, getApiRoot());
        return axios.get(serviceUrl, {
            headers: {
                'accept': 'application/json'
            }
        });
    },
};

export default ContactApi;